import * as React from 'react';
import { fieldValidation, rng } from '../../../amorg-common';
import { createUser } from '../../../api/userClientApi';
import { variants } from '../../../designSystem/Message';
import { Modal } from '../../../designSystem/Modal';
import { Button } from '../../../designSystem/button/Button';
import CreateUserForm, { UserData, getEmptyUserData } from './CreateUserForm';

type CreateUserModalButtonProps = {
    onUserCreated:()=>void;
}
export default function CreateUserModalButton(props:CreateUserModalButtonProps): JSX.Element
{
    const [showModal1, setShowModal1] = React.useState(false);
    const [userData, setUserData] = React.useState<UserData>(getEmptyUserData());
    const [result, setResult] = React.useState<
        {didSubmit:false} | 
        {didSubmit:true, success:true } |
        {didSubmit:true, success:false, errorMessage:string }
    >({didSubmit:false});

	const handleCancel = () => {
        setUserData(getEmptyUserData());
        setResult({didSubmit:false});
        setShowModal1(false);
	}

    async function handleSubmit(){
        const isValid = 
            // fieldValidation.site.id(userData.siteId) && 
            fieldValidation.user.firstname(userData.firstname) &&
            fieldValidation.user.middlename(userData.middlename) &&
            fieldValidation.user.lastname(userData.lastname) &&
            fieldValidation.user.email(userData.email) &&
            fieldValidation.user.password(userData.password) &&
            userData.passwordRepeated === userData.password;

        if(isValid){
            const result = await createUser(rng.getRandomId('u_'), userData.firstname, userData.middlename, userData.lastname, userData.email, userData.password);
            if(result.isSuccess){
                props.onUserCreated();
                setUserData(getEmptyUserData());
                setResult({didSubmit:true, success:true});
            }
            else{
                if(result.errorMessage === 'createUser_email_in_use')
                    setResult({didSubmit:true, success:false, errorMessage:'Email addressen er allerede i brug.'});
                else
                    setResult({didSubmit:true, success:false, errorMessage:'Kunne ikke oprette brugeren.'});
            }
        }
        else
            setResult({didSubmit:true, success:false, errorMessage:'Kan ikke oprette brugeren da der er fejl i et eller flere felter.'});
    }

    let message:{type:variants, text:string} | undefined = undefined;
    if(result.didSubmit){
        if(result.success === true)
            message = { type:'success', text:'Bruger oprettet!'};
        else
            message = { type:'error', text:result.errorMessage };
    }

    return (
        <>
            
            <Button variant={"filled"} text="Opret ny bruger" icon="actions_plus" size={"42px"} emphasize onClick={() => setShowModal1(true)} />   
            <Modal
                title='Opret bruger'
                content={
                    <CreateUserForm
                        userData={userData}
                        message={message}
                        displaySite={false}
                        disableCreateButton={false}
                        disableValidation={!result.didSubmit || (result.didSubmit && result.success) }
                        onUserDataChange={(data) => setUserData(data)}
                        onCreateUser={handleSubmit} 
                        onCreateUserCancel={handleCancel} />
                }
                showModal={showModal1}
                onCancel={handleCancel}/>
        </>
    );
}